import { markAllReadAdminNotifications } from "services/notification.service";
import NotificationCardSkeleton from "./NotificationCardSkeleton";
import { SearchField } from "components";
import NotificationCard from "./NotificationCard";
import { toast } from "react-toastify";

export default function NotificationFeed({
  notifications,
  search,
  setSearch,
  handleRedirect,
  loading,
  setFilter,
  filter,
  setIsRenderComponent,
}) {
  const markAllAsRead = async () => {
    try {
      await markAllReadAdminNotifications();

      setIsRenderComponent((prev) => !prev);
    } catch (error) {
      toast.error("Error updating notifications");
    }
  };

  return (
    <div className="w-full">
      {/* Filter tabs */}
      <div className="p-4">
        <div className="flex items-center border dark:border-gray-800 rounded-md overflow-hidden">
          <button
            className={`transition-colors h-10 flex items-center justify-center w-full ${
              filter.isRead === ""
                ? "bg-secondary text-white dark:bg-alpha"
                : ""
            }`}
            onClick={() => setFilter((prev) => ({ ...prev, isRead: "" }))}
          >
            All
          </button>
          <button
            className={`transition-colors h-10 flex items-center justify-center w-full ${
              filter.isRead === false
                ? "bg-secondary text-white dark:bg-alpha"
                : ""
            }`}
            onClick={() => setFilter((prev) => ({ ...prev, isRead: false }))}
          >
            Unread
          </button>
        </div>
      </div>

      {/* Search and actions */}
      <div className="flex items-center justify-between p-4 gap-2">
        <div className="relative flex-1">
          <SearchField
            onChange={setSearch}
            value={search}
            mobilePlaceholder="Serach Notification"
            placeholder="Search Notification"
          />
        </div>
        <button onClick={markAllAsRead} className="font-bold hover:underline">
          Mark all as read
        </button>
      </div>

      {/* Notifications list */}
      <div>
        {loading ? (
          Array.from({ length: 6 }).map((_, index) => (
            <NotificationCardSkeleton key={index} />
          ))
        ) : notifications.length === 0 ? (
          <div className="text-center my-4">No new notifications.</div>
        ) : (
          notifications.map((notification) => (
            <NotificationCard
              key={notification.id}
              notification={notification}
              handleRedirect={handleRedirect}
            />
          ))
        )}
      </div>
    </div>
  );
}
